function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M304 0h-96C93.125 0 0 93.125 0 208c0 74.438 39.405 139.25 98.188 176H96v128l144-96h64c114.875 0 208-93.125 208-208S418.875 0 304 0zm0 352h-64l-80 48v-56.812C104.188 323.344 64 270.594 64 208c0-79.531 64.469-144 144-144h96c79.53 0 144 64.469 144 144s-64.469 144-144 144z" /></svg>;
});